.container {
  width: 100%;
}

.content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.message {
  font-size: 14px;
}

.countdown {
  font-size: 14px;
  white-space: nowrap;
}
